// Breaks apart words. Used in `./mapEvents`
module.exports = function(string) {
  return string.split(/\s+/);
};
